import { render, staticRenderFns } from "./SimpleHr.vue?vue&type=template&id=197e75eb&"
import script from "./SimpleHr.vue?vue&type=script&lang=js&"
export * from "./SimpleHr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports